import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaicabbooking() {



  const cardData = {


  keyword: "Pune to Mumbai Cab Booking",

  headingDescription: "Trustline Travels offers easy and reliable Pune to Mumbai cab booking services with comfortable, safe, and affordable taxis for business travel, airport transfers, family trips, corporate travel, and outstation journeys. Whether you need a one-way cab, round-trip taxi, or customized travel package, our experienced chauffeurs ensure timely pickups and a smooth travel experience. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, instant booking confirmation, doorstep pickup, flexible travel schedules, and 24/7 customer support, Trustline Travels is the trusted choice for Pune to Mumbai taxi booking services.",

  topPlaces: [
    {
      title: "Bandra East",
      description: "Bandra East is a prominent commercial locality featuring business offices, premium hotels, convention venues, and excellent connectivity across Mumbai."
    },
    {
      title: "Andheri West",
      description: "Andheri West is a bustling commercial and entertainment hub known for corporate offices, shopping destinations, restaurants, and metro connectivity."
    },
    {
      title: "Powai",
      description: "Powai is a modern business and residential destination with leading IT companies, corporate campuses, educational institutions, and premium hotels."
    },
    {
      title: "Vikhroli",
      description: "Vikhroli is a rapidly developing commercial area offering business parks, technology companies, and easy access to eastern Mumbai."
    },
    {
      title: "Millennium Business Park",
      description: "Millennium Business Park in Mahape is a leading IT destination with software companies, multinational corporations, and modern office infrastructure."
    },
    {
      title: "NESCO IT Park",
      description: "NESCO IT Park in Goregaon is a renowned business hub hosting technology companies, exhibitions, conferences, and corporate offices."
    },
    {
      title: "Marine Drive",
      description: "Marine Drive is Mumbai's iconic seaside boulevard, famous for its stunning Arabian Sea views and the spectacular Queen's Necklace skyline."
    },
    {
      title: "Global Vipassana Pagoda",
      description: "Global Vipassana Pagoda is a magnificent meditation monument known for its grand dome, peaceful surroundings, and spiritual significance."
    },
    {
      title: "Taraporewala Aquarium",
      description: "Taraporewala Aquarium is one of India's oldest aquariums, featuring a diverse collection of marine species and educational exhibits."
    },
    {
      title: "Bandra Fort",
      description: "Bandra Fort is a historic coastal landmark offering breathtaking views of the Arabian Sea and the iconic Bandra-Worli Sea Link."
    }
  ],






"services": [
  {
    "name": "Pune to Mumbai Round Trip Cab Fare",
    "description": "Check Pune to Mumbai round trip cab fare with affordable pricing for Sedan, Ertiga, Innova Crysta, and SUV cabs. Enjoy transparent fares, professional drivers, and comfortable travel."
  },
  {
    "name": "Pune to Mumbai Cab Fare",
    "description": "Get the latest Pune to Mumbai cab fare for one-way, round-trip, airport transfer, and outstation taxi services with fixed pricing."
  },
  {
    "name": "Pune to Mumbai Taxi Fare",
    "description": "Find Pune to Mumbai taxi fare with affordable rates, AC vehicles, and experienced chauffeurs for safe and comfortable travel."
  },
  {
    "name": "Pune to Mumbai Cab Price",
    "description": "Check Pune to Mumbai cab price for Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles with no hidden charges."
  },
  {
    "name": "Pune to Mumbai Round Trip Taxi",
    "description": "Book Pune to Mumbai round trip taxi for business, family trips, airport transfers, and same-day return travel."
  },
  {
    "name": "Pune to Mumbai Cab Booking",
    "description": "Book Pune to Mumbai cab online with instant confirmation, multiple vehicle options, and 24x7 customer support."
  },
  {
    "name": "Pune to Mumbai One Way Cab Fare",
    "description": "Check Pune to Mumbai one way cab fare with affordable single-trip pricing and reliable taxi service."
  },
  {
    "name": "Pune to Mumbai Outstation Cab",
    "description": "Hire Pune to Mumbai outstation cab with clean AC vehicles, professional drivers, and fixed pricing."
  },
  {
    "name": "Affordable Pune to Mumbai Cab",
    "description": "Choose affordable Pune to Mumbai cab service for budget-friendly travel without compromising on comfort and safety."
  },
  {
    "name": "Best Pune to Mumbai Cab Service",
    "description": "Travel with the best Pune to Mumbai cab service offering reliable drivers, well-maintained cars, and transparent pricing."
  },
  {
    "name": "Pune to Mumbai Airport Cab Fare",
    "description": "Check Pune to Mumbai Airport cab fare for Terminal 1, Terminal 2, domestic, and international airport transfers."
  },
  {
    "name": "Pune to Mumbai Cab Charges",
    "description": "Know Pune to Mumbai cab charges for Sedan, Ertiga, Innova Crysta, and SUV vehicles with fixed fare."
  },
  {
    "name": "Pune to Mumbai Intercity Cab",
    "description": "Book Pune to Mumbai intercity cab for comfortable business, leisure, and family travel with professional chauffeurs."
  },
  {
    "name": "Book Pune to Mumbai Cab",
    "description": "Reserve your Pune to Mumbai cab with easy online booking, instant confirmation, and 24x7 taxi availability."
  },
  {
    "name": "Fixed Fare Pune to Mumbai Cab",
    "description": "Book fixed fare Pune to Mumbai cab with transparent pricing and no hidden charges."
  },
  {
    "name": "Pune to Mumbai Cabs",
    "description": "Choose from a wide range of Pune to Mumbai cabs including Sedan, Ertiga, Innova Crysta, and SUV vehicles."
  },
  {
    "name": "Pune to Mumbai Cab Service",
    "description": "Reliable Pune to Mumbai cab service for airport transfers, one-way trips, round trips, and corporate travel."
  },
  {
    "name": "Pune to Mumbai Cheapest Cab",
    "description": "Find the cheapest Pune to Mumbai cab with affordable pricing, comfortable vehicles, and professional drivers."
  },
  {
    "name": "Pune Mumbai Taxi Service",
    "description": "Pune Mumbai taxi service offering clean AC vehicles, punctual pickups, and comfortable outstation travel."
  },
  {
    "name": "Pune to Mumbai Taxi One Way",
    "description": "Book Pune to Mumbai taxi one way and pay only for your single journey with fixed affordable fares."
  },
  {
    "name": "Pune Mumbai Cab One Way",
    "description": "Travel with Pune Mumbai one way cab service for convenient and economical outstation transportation."
  },
  {
    "name": "Pune Mumbai Cab Hire",
    "description": "Hire Pune Mumbai cab for business trips, family travel, airport transfers, and outstation journeys."
  },
  {
    "name": "Pune Mumbai Airport Cab Service",
    "description": "Book Pune Mumbai Airport cab service for timely airport pickup and drop with experienced drivers."
  },
  {
    "name": "Pune Mumbai Taxi Service Fare",
    "description": "Check Pune Mumbai taxi service fare with transparent pricing for all vehicle categories."
  },
  {
    "name": "Pune to Mumbai Airport Cab Booking",
    "description": "Book Pune to Mumbai Airport cab online for safe, comfortable, and on-time airport transfers."
  },
  {
    "name": "Pune to Mumbai Cab Round Trip",
    "description": "Reserve Pune to Mumbai cab round trip with flexible travel plans and affordable return packages."
  },
  {
    "name": "Pune to Mumbai Cab",
    "description": "Hire Pune to Mumbai cab for reliable, comfortable, and affordable intercity travel with doorstep pickup."
  },
  {
    "name": "Pune to Mumbai Taxi Booking",
    "description": "Book Pune to Mumbai taxi with instant confirmation and multiple AC vehicle options."
  },
  {
    "name": "Pune to Mumbai Taxi",
    "description": "Travel safely with Pune to Mumbai taxi service featuring experienced chauffeurs and well-maintained vehicles."
  },
  {
    "name": "Pune to Mumbai Taxi Service",
    "description": "Choose Pune to Mumbai taxi service for one-way, round-trip, airport transfers, and business travel."
  },
  {
    "name": "Online Pune to Mumbai Cab Booking",
    "description": "Complete your online Pune to Mumbai cab booking in minutes with secure payment and instant confirmation."
  },
  {
    "name": "Pune to Mumbai One Way Cab",
    "description": "Book Pune to Mumbai one way cab for affordable point-to-point travel without return charges."
  },
  {
    "name": "Pune to Mumbai Round Trip Cab",
    "description": "Hire Pune to Mumbai round trip cab for family tours, meetings, and same-day return travel."
  },
  {
    "name": "Pune to Mumbai Car Rental",
    "description": "Choose Pune to Mumbai car rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, and SUV vehicles."
  },
  {
    "name": "Pune to Mumbai Private Cab",
    "description": "Hire a private Pune to Mumbai cab with flexible pickup time, clean AC vehicles, and experienced drivers."
  },
  {
    "name": "Pune to Mumbai Airport Cab",
    "description": "Book Pune to Mumbai Airport cab for reliable transfers to Mumbai domestic and international terminals."
  },
  {
    "name": "Pune to Mumbai Drop Taxi",
    "description": "Reserve Pune to Mumbai drop taxi for one-way airport, business, and outstation travel."
  },
  {
    "name": "Pune Mumbai Taxi Booking",
    "description": "Pune Mumbai taxi booking with instant confirmation, affordable pricing, and professional chauffeurs."
  },
  {
    "name": "Pune Mumbai Cab Service",
    "description": "Reliable Pune Mumbai cab service with multiple vehicle choices for business, family, and airport travel."
  },
  {
    "name": "Pune to Mumbai AC Cab",
    "description": "Travel comfortably with Pune to Mumbai AC cab featuring sanitized vehicles and experienced drivers."
  },
  {
    "name": "Pune to Mumbai Travel Cab",
    "description": "Book Pune to Mumbai travel cab for leisure trips, business travel, airport transfers, and family journeys."
  }
],

"tableData": [
  ["Pune to Mumbai Round Trip Cab Fare", "Pune to Mumbai Cab Fare"],
  ["Pune to Mumbai Taxi Fare", "Pune to Mumbai Cab Price"],
  ["Pune to Mumbai Round Trip Taxi", "Pune to Mumbai Cab Booking"],
  ["Pune to Mumbai One Way Cab Fare", "Pune to Mumbai Outstation Cab"],
  ["Affordable Pune to Mumbai Cab", "Best Pune to Mumbai Cab Service"],
  ["Pune to Mumbai Airport Cab Fare", "Pune to Mumbai Cab Charges"],
  ["Pune to Mumbai Intercity Cab", "Book Pune to Mumbai Cab"],
  ["Fixed Fare Pune to Mumbai Cab", "Pune to Mumbai Cabs"],
  ["Pune to Mumbai Cab Service", "Pune to Mumbai Cheapest Cab"],
  ["Pune Mumbai Taxi Service", "Pune to Mumbai Taxi One Way"],
  ["Pune Mumbai Cab One Way", "Pune Mumbai Cab Hire"],
  ["Pune Mumbai Airport Cab Service", "Pune Mumbai Taxi Service Fare"],
  ["Pune to Mumbai Airport Cab Booking", "Pune to Mumbai Cab Round Trip"],
  ["Pune to Mumbai Cab", "Pune to Mumbai Taxi Booking"],
  ["Pune to Mumbai Taxi", "Pune to Mumbai Taxi Service"],
  ["Online Pune to Mumbai Cab Booking", "Pune to Mumbai One Way Cab"],
  ["Pune to Mumbai Round Trip Cab", "Pune to Mumbai Car Rental"],
  ["Pune to Mumbai Private Cab", "Pune to Mumbai Airport Cab"],
  ["Pune to Mumbai Drop Taxi", "Pune Mumbai Taxi Booking"],
  ["Pune Mumbai Cab Service", "Pune to Mumbai AC Cab"],
  ["Pune to Mumbai Travel Cab", "Pune to Mumbai Cab Service"]
],





whychoose: [
  {
    WhyChooseheading: "Easy Pune to Mumbai Cab Booking",
    WhyChoosedescription: "Trustline Travels makes Pune to Mumbai cab booking simple with quick confirmations, comfortable vehicles, and dependable travel services."
  },
  {
    WhyChooseheading: "Instant Booking Confirmation",
    WhyChoosedescription: "Receive immediate fare quotations and fast booking confirmation for your Pune to Mumbai journey without unnecessary delays."
  },
  {
    WhyChooseheading: "Professional & Courteous Drivers",
    WhyChoosedescription: "Our experienced chauffeurs ensure a safe, punctual, and comfortable ride throughout the Pune-Mumbai Expressway."
  },
  {
    WhyChooseheading: "Affordable Fare with Complete Transparency",
    WhyChoosedescription: "Book your cab with confidence through competitive pricing, detailed fare estimates, and no hidden charges."
  },
  {
    WhyChooseheading: "Multiple Vehicle Choices",
    WhyChoosedescription: "Select from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your travel needs."
  },
  {
    WhyChooseheading: "One Way, Round Trip & Airport Transfers",
    WhyChoosedescription: "We offer flexible booking options for one-way journeys, return trips, Mumbai Airport transfers, and corporate travel."
  },
  {
    WhyChooseheading: "Available 24 Hours Every Day",
    WhyChoosedescription: "Book your Pune to Mumbai cab anytime with round-the-clock service for early morning, daytime, or late-night travel."
  },
  {
    WhyChooseheading: "Trusted Travel Partner",
    WhyChoosedescription: "Thousands of travelers choose Trustline Travels for reliable service, well-maintained vehicles, and hassle-free outstation journeys."
  }
]

};

const faqData = [
  {
    question: "How can I book a Pune to Mumbai cab with Trustline Travels?",
    answer: "Simply share your pickup location, destination, travel date, preferred vehicle, and passenger details to receive an instant quotation and booking confirmation."
  },
  {
    question: "Do you provide one-way Pune to Mumbai cab booking?",
    answer: "Yes, we offer affordable one-way cab bookings from Pune to Mumbai with flexible pickup timings."
  },
  {
    question: "Can I book a round-trip cab from Pune to Mumbai?",
    answer: "Yes, Trustline Cab provides customized round-trip cab packages for business, family, and leisure travel."
  },
  {
    question: "Which vehicles are available for Pune to Mumbai cab booking?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for every travel requirement."
  },
  {
    question: "Do you provide Mumbai Airport cab bookings?",
    answer: "Yes, we offer direct cab services to Mumbai Airport Terminal 1, Terminal 2, and all major locations across Mumbai."
  },
  {
    question: "Are toll and parking charges included in the cab fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically mentioned in your booking quotation."
  },
  {
    question: "Is Pune to Mumbai cab booking available 24/7?",
    answer: "Yes, our booking services are available throughout the day and night for your convenience."
  },
  {
    question: "Can I reserve my cab in advance?",
    answer: "Yes, advance booking is recommended to secure your preferred vehicle and travel schedule."
  },
  {
    question: "Do you provide cabs for corporate and family travel?",
    answer: "Yes, our services are ideal for business meetings, airport transfers, family vacations, hotel transfers, and outstation travel."
  },
  {
    question: "Why should I choose Trustline Travels for Pune to Mumbai cab booking?",
    answer: "Trustline Travels offers transparent pricing, professional drivers, clean vehicles, flexible travel options, and dependable customer support for every trip."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vivek Chavan",
    feedback: "Booking a Pune to Mumbai cab with Trustline Travels was quick and hassle-free. The driver arrived on time, the vehicle was well-maintained, and the journey was smooth throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aarti Kulkarni",
    feedback: "I regularly book cabs from Pune to Mumbai with Trustline Travels for business travel. Their professional service, transparent pricing, and comfortable cars make every trip enjoyable.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Cab Booking Service",
  "image": "https://www.trustlinetravels.com/assets/images/pune-to-mumbai-cab-booking.webp",
  "description": "Book Pune to Mumbai cab service with Trustline Travels for safe, comfortable, and affordable travel. Get one-way, round-trip, airport, and outstation taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7216"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pune-to-mumbai-cab-booking"
  }
};



  return (
    <div>
<Helmet>
  <title>Pune to Mumbai Cab Booking | One Way & Round Trip Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pune to Mumbai cab online with Trustline Travels. Get affordable one-way, round-trip, airport, and outstation taxi services with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="Pune to Mumbai Round Trip Cab Fare, Pune to Mumbai Cab Fare, Pune to Mumbai Taxi Fare, Pune to Mumbai Cab Price, Pune to Mumbai Round Trip Taxi, Pune to Mumbai Cab Booking, Pune to Mumbai One Way Cab Fare, Pune to Mumbai Outstation Cab, Affordable Pune to Mumbai Cab, Best Pune to Mumbai Cab Service, Pune to Mumbai Airport Cab, Pune Mumbai taxi booking, Pune to Mumbai online cab booking, Pune Mumbai airport taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/61.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaicabbooking;